/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from 'react';
import { Col, Row } from 'reactstrap';
import { useQuery } from '@apollo/client';
import {
  STAFF_LIST_QUERY,
  STAFF_LIST_QUERY_SUBSCRIPTION,
} from 'pages/Staff/StaffgraphQL';
import { ADD_EDIT_CONSTANT, defaultDeleteFilter } from 'utils/constants';
import { cloneDeep, isEmpty } from 'lodash';
import StaffCard from 'components/StaffCard';
import Loader from 'components/common/Loader';
import NoDataFound from 'components/NoDataFound';
import ErrorMessage from 'components/ErrorMessage';

const buildFilters = (search, department, satffType, op) => {
  const filters = [
    {
      key: 'userSearchFilter',
      value: search || '',
      type: 'STRING',
      op: 'LIKE',
    },
    {
      key: 'name',
      value: department ? 'TRADER' : satffType,
      setAttribute: 'roles',
      type: 'STRING',
      op: department ? 'NOT_IN' : op,
    },
  ];

  if (department) {
    filters.push({
      key: 'department',
      value: department,
      setAttribute: 'roles',
      type: 'STRING',
      op: 'EQ',
    });
  }

  filters.push({ ...defaultDeleteFilter });
  return filters;
};

const StaffsTable = ({
  handleViewDetail,
  toggleAddRecord,
  handleDelete,
  searchString,
  satffType = 'TRADER',
  department,
  op = 'NOT_IN',
}) => {
  const queryVariables = useMemo(
    () => ({
      filter: buildFilters(searchString, department, satffType, op),
      pageNo: 1,
      pageSize: 10,
      sortCol: 'id',
      sortDirection: 'DESC',
      pagination: false,
    }),
    [searchString, department, satffType, op],
  );

  const { data, loading, error, refetch, subscribeToMore } = useQuery(
    STAFF_LIST_QUERY,
    {
      variables: queryVariables,
      fetchPolicy: 'network-only',
    },
  );

  useEffect(() => {
    const deletedObj = queryVariables.filter.filter(
      (val) => val.key !== 'isDeleted',
    );
    const unsubscribe = subscribeToMore({
      document: STAFF_LIST_QUERY_SUBSCRIPTION,
      variables: { ...queryVariables, filter: deletedObj },
      updateQuery: (prev, { subscriptionData }) => {
        const newData = cloneDeep(prev);
        const indexFound = newData?.usersFilter.users.findIndex(
          (val) => val.id === subscriptionData?.data?.usersFilter?.user?.id,
        );
        if (!prev || isEmpty(prev)) return '';
        if (!subscriptionData.data) return prev;
        if (!subscriptionData?.data?.usersFilter?.user?.id) return prev;

        if (subscriptionData?.data?.usersFilter?.action === 'CREATED') {
          const newUser = subscriptionData?.data?.usersFilter?.user;
          const updatedUsers = [newUser, ...newData.usersFilter.users];
          const newTotalCount = prev.usersFilter.totalCount + 1;
          const newTotalPages = Math.ceil(
            newTotalCount / queryVariables.pageSize,
          );
          newData.usersFilter = {
            ...newData.usersFilter,
            totalCount: newTotalCount,
            totalPages: newTotalPages,
            users: updatedUsers,
          };
        }

        if (subscriptionData?.data?.usersFilter?.action === 'UPDATED') {
          newData.usersFilter.users[indexFound] =
            subscriptionData.data.usersFilter.user;
        }

        if (subscriptionData?.data?.usersFilter?.action === 'DELETED') {
          const { id } = subscriptionData?.data?.usersFilter?.user;
          const updatedUsers = prev.usersFilter.users.filter(
            (val) => val.id !== id,
          );
          const newTotalCount = prev.usersFilter.totalCount - 1;
          const newTotalPages = Math.ceil(
            newTotalCount / queryVariables.pageSize,
          );
          newData.usersFilter = {
            ...newData.usersFilter,
            totalCount: newTotalCount,
            totalPages: newTotalPages,
            users: updatedUsers,
          };
        }
        return newData;
      },
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return <ErrorMessage error={error} />;
  }

  const handleViewItem = (item) => () => handleViewDetail(item);
  const handleEditItem = (item) => () =>
    toggleAddRecord(item, ADD_EDIT_CONSTANT.EDIT, refetch);

  return (
    <div>
      {!loading && data?.usersFilter?.users?.length ? (
        <Row xs={2} sm={2} lg={4} xxl={5}>
          {data?.usersFilter?.users?.map((item) => (
            <Col key={item?.id}>
              <StaffCard
                {...item}
                keyValue={item?.id}
                handleViewDetail={handleViewItem(item)}
                handleAddEditRecord={handleEditItem(item)}
                handleDelete={handleDelete}
              />
            </Col>
          ))}
        </Row>
      ) : (
        <NoDataFound message="No Data Found!" />
      )}
    </div>
  );
};

export default StaffsTable;
